export default "/images/5ba7d8fe7037238a70f09db4246a1e73.avif";